(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moonlights-collapsible-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!(item instanceof HTMLDetailsElement)) return;
    if (!item.open) return;
    const section = item.closest('[data-faq-section]');
    if (!section) return;
    if (section.dataset.allowMultiple === 'true') return;
    section.querySelectorAll('details[open]').forEach((otherItem) => {
      if (otherItem !== item) otherItem.removeAttribute('open');
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moonlights-customer-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-gallery-open]');
    if (openButton) {
      const modal = document.getElementById(openButton.dataset.galleryOpen);
      if (modal && typeof modal.showModal === 'function') modal.showModal();
      return;
    }

    const mediaButton = event.target.closest('[data-gallery-media-prev], [data-gallery-media-next], [data-gallery-thumb]');
    if (mediaButton) {
      const media = mediaButton.closest('[data-gallery-modal-media]');
      if (!media) return;
      const slides = Array.from(media.querySelectorAll('[data-gallery-slide]'));
      const thumbs = Array.from(media.querySelectorAll('[data-gallery-thumb]'));
      if (slides.length < 2) return;
      const current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let next = current;
      if (mediaButton.hasAttribute('data-gallery-thumb')) {
        next = Number.parseInt(mediaButton.dataset.galleryThumb, 10);
      } else if (mediaButton.hasAttribute('data-gallery-media-next')) {
        next = (current + 1) % slides.length;
      } else {
        next = (current - 1 + slides.length) % slides.length;
      }
      slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === next);
        if (index !== next) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      thumbs.forEach((thumb, index) => thumb.classList.toggle('is-active', index === next));
      return;
    }

    const closeButton = event.target.closest('[data-gallery-close]');
    if (closeButton) {
      const modal = closeButton.closest('[data-gallery-modal]');
      if (modal) modal.close();
      return;
    }

    const button = event.target.closest('[data-gallery-prev], [data-gallery-next]');
    if (!button) return;
    const gallery = button.closest('.moonlights-customer-gallery');
    const track = gallery && gallery.querySelector('[data-gallery-track]');
    if (!track) return;
    const card = track.querySelector('.moonlights-customer-gallery__card');
    const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
    const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    const direction = button.hasAttribute('data-gallery-next') ? 1 : -1;
    track.scrollBy({ left: distance * direction, behavior: 'smooth' });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.matches('[data-gallery-modal]')) return;
    const bounds = event.target.getBoundingClientRect();
    const inDialog = event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
    if (!inDialog) event.target.close();
  });

  document.addEventListener('close', (event) => {
    if (!event.target.matches('[data-gallery-modal]')) return;
    event.target.querySelectorAll('video').forEach((video) => video.pause());
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moonlights-image-with-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupVideos = (root = document) => {
      root.querySelectorAll('.ml-image-text__video[data-ml-autoplay="true"]').forEach((video) => {
        video.muted = true;
        video.playsInline = true;

        const playVideo = () => {
          video.play().catch(() => {});
        };

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                playVideo();
                observer.disconnect();
              }
            });
          }, { rootMargin: '200px' });

          observer.observe(video);
        } else {
          playVideo();
        }

        if (video.readyState >= 2) {
          playVideo();
        } else {
          video.addEventListener('canplay', playVideo, { once: true });
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setupVideos());
    } else {
      setupVideos();
    }

    document.addEventListener('shopify:section:load', (event) => setupVideos(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
